import { render, staticRenderFns } from "./USC_21_010.vue?vue&type=template&id=12b15527&scoped=true"
import script from "./USC_21_010.vue?vue&type=script&lang=js"
export * from "./USC_21_010.vue?vue&type=script&lang=js"
import style0 from "./USC_21_010.vue?vue&type=style&index=0&id=12b15527&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b15527",
  null
  
)

export default component.exports